import {newCOLORS} from 'core/styles';
import ActionButton from 'features/generic/components/ActionButton/ActionButton';
import ActionPanel from 'features/generic/components/ActionPanel/ActionPanel';
import Button from 'features/generic/components/Button/Button';
import IconChevron from 'features/icons/IconChevron';
import Modal from 'features/modal/components/Modal/Modal';
import {useState} from 'react';
import styled from 'styled-components';

const FilterLabel = styled.div`
    border-radius: 100px;
    border: 1px solid #ddd;
    padding: 4px 8px 4px 12px;
    display: flex;
    align-items: center;
    min-height: 36px;
    width: auto;
    margin-right: 16px;

    &:hover {
        cursor: pointer;
    }
`;

const FilterDropdown = styled.div`
    background: #fff;
    left: 0;
    top: 8px;
    position: absolute;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3), 0px 4px 8px 3px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    min-width: 300px;
    max-height: 500px;
    overflow-y: scroll;

    .filter {
        color: ${newCOLORS.gray500};
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        font-weight: 500;
        min-height: 24px;
        padding: 10px;

        &:hover {
            cursor: pointer;
            color: ${newCOLORS.gray400};
        }

        label {
            color: ${newCOLORS.gray500};
            margin-bottom: 0;
            min-height: 24px;
            align-items: center;
            display: flex;

            &:hover {
                cursor: pointer;
                color: ${newCOLORS.gray400};
            }
        }

        input {
            margin: 0 5px 0 0;
        }
        input:after,
        input:checked:after {
            width: 24px;
            height: 24px;
        }
        input:checked:before {
            left: 9px;
            height: 15px;
        }
    }
    .filter:last-child {
        margin-bottom: 0;
    }
    .filter.active {
        background-color: ${newCOLORS.primary};
        color: ${newCOLORS.primary300};
    }

    .controls {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 14px;
        padding: 0 10px 10px 10px;

        button:hover {
            cursor: pointer;
        }

        .clear {
            color: ${newCOLORS.gray400};
            font-weight: 500;
            background: #fff;
            padding-left: 0;
        }
        .clear:hover {
            text-decoration: underline;
        }

        .apply {
            border-radius: 8px;
            color: #fff;
            background: ${newCOLORS.primary300};
            width: 175px;
            height: 36px;
            font-weight: bold;

            &:hover {
                opacity: 0.9;
            }
        }
    }
`;

export const FilterPopover = ({
    label,
    children,
    handleApply,
    handleReset,
    closeOnClick,
}) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <div>
            <FilterLabel className="text-sm" onClick={() => setShowModal(true)}>
                {label} <IconChevron fill="#1a1a1a" />
            </FilterLabel>
            {showModal && (
                <Modal handleClose={() => setShowModal(false)}>
                    <FilterDropdown
                        onClick={() => (closeOnClick ? setShowModal(false) : {})}>
                        {children}
                        {(handleReset || handleApply) && (
                            <div className="controls text-sm">
                                {handleReset && (
                                    <button
                                        className="clear"
                                        onClick={() => {
                                            handleReset && handleReset();
                                            setShowModal(false);
                                        }}>
                                        Reset
                                    </button>
                                )}
                                {handleApply && (
                                    <button
                                        className="apply"
                                        onClick={() => {
                                            handleApply && handleApply();
                                            setShowModal(false);
                                        }}>
                                        Apply
                                    </button>
                                )}
                            </div>
                        )}
                    </FilterDropdown>
                </Modal>
            )}
        </div>
    );
};
